// Sales Projects presentation — the customer-facing counterpart to
// ../projects/projectWorkspaceTabs.js. Every tab here is read-mostly and
// backed by the exact same account-scoped project/document/inventory
// endpoints the admin workspace uses (Nexceo::AccessPolicy already gates
// all of them server-side) — this file only decides which tabs render and
// what each one links to; it introduces no new backend concept.
export const SALES_PROJECT_TABS = [
  { key: 'overview', label: 'Overview', icon: 'i-lucide-layout-dashboard' },
  { key: 'documents', label: 'Documents', icon: 'i-lucide-file-text' },
  { key: 'inventory', label: 'Inventory', icon: 'i-lucide-layout-grid' },
  { key: 'media', label: 'Media', icon: 'i-lucide-image' },
  { key: 'maps', label: 'Maps & Surrounding', icon: 'i-lucide-map-pin' },
  { key: 'immersive', label: 'Immersive Walkthrough', icon: 'i-lucide-eye' },
];

export function salesProjectTabs({ id, accountId }) {
  return SALES_PROJECT_TABS.map(tab => ({
    ...tab,
    to: {
      name: 'nexceo_sales_project_show',
      params: { id, accountId, tab: tab.key },
    },
  }));
}
